<template>
    <sf-sticker class="sf-sticker--nearly-opened">
        {{ t('title') }}
    </sf-sticker>
</template>

<script setup>
import SfSticker from '~/patterns/atoms/sticker/sticker';

const { t } = useI18n({
    useScope: 'local'
});
</script>

<i18n lang="json">
{
    "nl": {
        "title": "opent bijna"
    },
    "en": {
        "title": "nearly open"
    }
}
</i18n>
